import { all } from 'redux-saga/effects';

import authSagas from './authSagas';
import signupSagas from './signupSagas';
import scribeSagas from './scribeSagas';
import imagesSagas from './imagesSagas';
import uiSagas from './uiSagas';
import routerSagas from './routerSagas';
import downloadSagas from './downloadSagas';
import paymentSagas from './paymentSagas';
import pollDownloadSagas from './pollDownloadSagas';
import checkoutSagas from './checkoutSagas';
import locationSagas from './locationSagas';
import monitoringSaga from './monitoringSaga';
import templatesSaga from './templatesSaga';
import fontSagas from './fontSagas';
import marketingSagas from './marketingSagas';
import playbackSagas from './playbackSagas';
import editorSagas from './editorSagas';
import mixpanelSagas from './mixpanel';
import userSettings from './userSettingsSagas';
import userpilotSagas from './userpilot';
import croppingSagas from './croppingSagas';
import cursorSagas from './cursorSagas';
import elementSagas from './elementSagas';
import hotjarSagas from './hotjar';
import imageUploadSagas from './imageUploadSagas';
import appStartupSagas from './appStartupSagas';

export default function* sagas() {
  yield all([
    monitoringSaga(),
    mixpanelSagas(),
    authSagas(),
    signupSagas(),
    appStartupSagas(),
    scribeSagas(),
    imagesSagas(),
    uiSagas(),
    routerSagas(),
    paymentSagas(),
    pollDownloadSagas(),
    checkoutSagas(),
    downloadSagas(),
    locationSagas(),
    templatesSaga(),
    fontSagas(),
    marketingSagas(),
    editorSagas(),
    playbackSagas(),
    userSettings(),
    userpilotSagas(),
    croppingSagas(),
    cursorSagas(),
    elementSagas(),
    hotjarSagas(),
    imageUploadSagas()
  ]);
}
